import React from "react";
import {
  Grid,
  Typography,
  IconButton,
  Tooltip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Link,
} from "@material-ui/core";
import moment from "moment";

import DeleteIcon from "@material-ui/icons/Delete";

export const FileLists = React.memo((props) => {
  const { fileList, openImageModal, documentDeleteHandler } = props;

  const filteredFiles = fileList.filter(
    (file) => file.fileType === "bookingFile",
  );

  return (
    <Grid item xs={6}>
      <Typography
        variant="h6"
        style={{
          fontSize: "14px",
          fontWeight: "bold",
          color: "#333",
          marginBottom: "10px",
        }}
      >
        Documents
      </Typography>

      {filteredFiles.length === 0 ? (
        <Typography variant="body2">No files</Typography>
      ) : (
        <TableContainer component={Paper} elevation={1}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>
                  <b>Document Name</b>
                </TableCell>
                <TableCell>
                  <b>Date & Time</b>
                </TableCell>
                <TableCell align="center">
                  <b>Action</b>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {filteredFiles.map((file, index) => (
                <TableRow key={index}>
                  {/* Document Name (Clickable) */}
                  <TableCell>
                    <Link
                      component="button"
                      variant="body2"
                      onClick={() => openImageModal(file.fileName)}
                    >
                      {file.orginalFile}
                    </Link>
                  </TableCell>

                  {/* Date & Time */}
                  <TableCell>
                    <Tooltip
                      title={moment(file.updatedAt).format(
                        "dddd, MMMM Do YYYY, HH:mm:ss",
                      )}
                    >
                      <span>
                        {moment(file.updatedAt).format("DD MMM YYYY, HH:mm")}
                      </span>
                    </Tooltip>
                  </TableCell>

                  {/* Delete Action */}
                  <TableCell align="center">
                    <IconButton
                      edge="end"
                      aria-label="delete"
                      onClick={() => documentDeleteHandler(file.fileName)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Grid>
  );
});
